<template>
  <div class="row">
    <div class="col">
      <div>
        <div class="widget">
          <div class="row vertical-align align-items-center">
            <button
              type="button"
              class="btn btn-circle btn-lg btn-primary mr-2"
            >
              <i class="fa fa-cogs" />
            </button>

            <h4>Integrador</h4>
          </div>
        </div>

        <ul
          class="list-group list-group-flush bg-white"
          v-for="(item, index) in integrador"
          :key="index"
        >
          <router-link :to="`${item.path}`">
            <li class="list-group-item text-secondary">
              {{ $t(item.text) }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { integrador } from "@/config/settings";

export default {
  name: "TestSettingsList",
  data: () => ({
    integrador: integrador(),
  }),
};
</script>
